import type { AnimationSource } from "@src/features/equation-editor/hooks/use-animation-progress";
import { EquationEditorView } from "@src/features/equation-editor/components/EquationEditorView";
import type { Translate } from "@src/i18n/translate";
import { getAnimationFrame } from "@src/features/playback/playback";
import { getAnimationProgress } from "@src/features/playback/animation";
import { selectActiveEquation } from "../state/app-state";
import { useAppStore } from "../hooks/use-app-store";
import { useAppStoreApi } from "../state/app-store-context";
import { useMemo } from "react";

export function EquationEditor({ t }: { t: Translate }) {
  const store = useAppStoreApi();
  const equation = useAppStore(selectActiveEquation);
  const commands = store.getState();
  const animationSource = useMemo<AnimationSource>(
    () => ({
      getSnapshot: () => store.getState().animation,
      getProgress: (currentEquation, now: number) =>
        getAnimationProgress(
          currentEquation.evaluation.value,
          getAnimationFrame(store.getState().animation, now),
        ),
      subscribe: (listener: () => void) =>
        store.subscribe(() => {
          listener();
        }),
    }),
    [store],
  );
  return (
    <EquationEditorView
      equation={equation}
      animationSource={animationSource}
      actions={commands}
      t={t}
    />
  );
}
